export class BasketItem {
    constructor(id, ticker, name, url = '', active = false, unlinked = false, shareClass = [''], sfdr = null, isAlternative = false, nonSustainableId = null, inactivated = false, assetClass = null, alternativeCounter = 0, alternativeOrder = -1) {
        this.id = id;
        this.ticker = ticker;
        this.name = name;
        this.url = url;
        this.active = active;
        this.unlinked = unlinked;
        this.shareClass = shareClass;
        this.sfdr = sfdr;
        this.isAlternative = isAlternative;
        this.nonSustainableId = nonSustainableId;
        this.inactivated = inactivated;
        this.assetClass = assetClass;
        this.alternativeCounter = alternativeCounter;
        this.alternativeOrder = alternativeOrder;
    }
}
export const mapDataResponseToBasketItem = (response) => {
    const fundData = new BasketItem(response.id, response.ticker, response.name, response.url, response.active, response.unlinked, response.shareClass, response.sfdr);
    fundData.timestamp = new Date();
    return fundData;
};
